
import { Company } from '../companies/company.model';
import { Note } from '../../shared/notes/note.model';
import { Communication } from '../../shared/communications/communication.model';
import { BooleanDate } from '../../shared/models/boolean-date.model';
import { Project } from './project.model';
import { Contact } from '../contacts/contact.model';
import { ProjectStep } from './components/project-steps/project-step.model';
import { Task } from '../../shared/tasks/task.model';
import { Attachment } from '../../shared/attachments/attachment.model';
// import { ProjectProgress } from './components/project-steps/project-step.model';

export class Purchase {

    _id?: string;

    /* the company to which the purcahse relates */
    company: Company;
    client: Company;
    // project: Project; // removed
    clientApproved: boolean;
    priority: string;
    currentStage: string = '';
    clientComments: string = '';
    internalComments: string = '';

    sentNDA: BooleanDate = new BooleanDate();
    signedNDA: BooleanDate = new BooleanDate();
    sentIM: BooleanDate = new BooleanDate();
    mainContact?: Contact;
    communications: Communication[] = [];
    attachments: Attachment[] = [];
    tasks: Task[] = [];
    notes: Note[] = [];

    stepHistory?: StepHistory[] = [];

    /* eventually? */
    bids: {
        amount: number,
        bidDate: Date
    };
    misc:{
        companyName: string,
        companyId: string,
        logoUrl: string,
        mainContact:string,
        mainContactId: string,
        employees:Contact[]
    }

    constructor(company: Company, client: Company) {
        this.company = company;
        // this.project = project._id;
        this.client = client;
    }

}

// use to track the scores for the steps
export class StepHistory {

    step: ProjectStep;
    score: number = 0;
    date: Date;

    constructor(step: ProjectStep, score: number, date: Date = new Date()) {
        this.step = step;
        this.score = score;
        this.date = date;
    }

}

export enum PurchasePriorityLevel {
    A,
    B,
    C,
    M
}

// xxx are to be used in conjunction with a pipe to replace with a hyphen (couldn't think of another way to use an enum)
// export enum PurchaseInterest {
//     NotYetSet,
//     PreferredBidder,
//     MadeOffer,
//     ExpressedInterest,
//     ReviewingIM,
//     AxxxHighPriority,
//     AxxxConsidering,
//     AxxxMakingContact,
//     AxxxToBeContacted,
//     BxxxLowPriority,
//     BxxxConsidering,
//     BxxxMakingContact,
//     BxxxToBeContacted,
//     ConsideredButRejected,
//     NotToBeContacted,
//     NotInterested,
//     MassMarketList,
//     Unknown
// }





// WEBPACK FOOTER //
// ./client/app/features/projects/purchase.model.ts